/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecoveryServiceReportRes {
    getFixupPrototypeFunction() { return RecoveryServiceReportRes.fixupPrototype; }

    static newInstance(model: Partial<RecoveryServiceReportRes>): RecoveryServiceReportRes {
        let obj = Object.assign(new RecoveryServiceReportRes(), model);
        RecoveryServiceReportRes.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecoveryServiceReportRes>): RecoveryServiceReportRes {
        if (!model) return null;
        return RecoveryServiceReportRes.newInstance(<RecoveryServiceReportRes> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecoveryServiceReportRes) {
        if (!obj) return;

        models.RecoveryServiceReportRes.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecoveryServiceReportRes): boolean {
        Object.setPrototypeOf(obj, RecoveryServiceReportRes.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * status response
     */
    status: string;

    /**
     * message response
     */
    message: string;

    /**
     * recovery service data
     */
    data: any;

}
